import { INVALID } from '../constants/orders';

export const isInvalid = status =>
  status === INVALID;

export default isInvalid;
